export const LAYER_ID = 'contoursLayer';
export const LAYER_NAME = 'Contours';
export const SIDEBAR_ID = 'contoursSettings';

export const COLOR_CHANGE_DEBOUNCE_TIME = 300;
export const DATA_FETCH_RETRY_COUNT = 1;

export const INTERVAL_KEYS = Object.freeze({
	COARSE: 'coarse',
	MEDIUM: 'medium',
	FINE: 'fine',
	EXTRA_FINE: 'extra_fine',
});

/**
 * Available contour interval options
 * These define the different detail levels for contour line display
 */
export const INTERVAL_OPTIONS = [
	{ key: INTERVAL_KEYS.COARSE, label: 'Coarse (2m interval)' },
	{ key: INTERVAL_KEYS.MEDIUM, label: 'Medium (1m interval)' },
	{ key: INTERVAL_KEYS.FINE, label: 'Fine (0.5m interval)' },
	{ key: INTERVAL_KEYS.EXTRA_FINE, label: 'Extra Fine (0.25m interval)' },
];

/**
 * Default contour line color (bright orange-red that contrasts well with green forest)
 */
export const DEFAULT_CONTOUR_COLOR = { r: 255, g: 82, b: 82, a: 1 };
